<div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="10" tabindex="0">
    <app-header></app-header>
    <main id="mainContent" tabindex="-1">
        <app-whatsapp></app-whatsapp>

        <!-- HERO -->
        <section class="position-relative">
            <div class="position-relative faculty-hero d-flex">
                <div class="slid-img position-absolute w-100 h-100 top-0 end-0 overflow-hidden">
                    <img class="position-absolute" [src]="SLIDER_IMAGE" alt="" />
                    <div class="black-layer position-absolute top-0 end-0 h-100 w-100"></div>
                </div>
                <div
                    class="position-relative d-flex align-items-lg-end justify-content-center institute-pref flex-column inner">
                    <div class="blend-darken-bg position-absolute top-0 end-0 h-100 w-100"></div>
                    <div
                        class="pref position-relative text-white pe-lg-5 pe-3 ms-3 animate__animated animate__slideInRight wow">
                        <h2 class="heading-font d-inline-block pt-5">
                            <label class="d-block text-sm-start">{{facult_date}}</label>
                            {{facultyName}}
                        </h2>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb animate__animated animate__fadeInDown">
                                <li class="breadcrumb-item mb-2 mb-md-0">
                                    <a class="text-white">أكادميه الفنون</a>
                                </li>
                                <li class="breadcrumb-item mb-2 mb-md-0">
                                    <a class="text-white">{{facultyName}}</a>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    أعضاء هيئة التدريس
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </section>

        <!-- PROFILE + CONTENT -->
        <section class="member-section pb-5">
            <div class="container">

                <!-- Profile card (overlaps hero) -->
                <div class="member-card animate__animated animate__fadeInUp wow">
                    <div class="member-avatar">
                        <img [src]="techDetails?.image ? techDetails.image : 'assets/img/instructor-default.png'"
                            [alt]="techDetails?.full_name" alt="" />
                    </div>
                    <div class="member-head">
                        <h1 class="heading-font member-name">{{techDetails?.full_name}}</h1>
                        <div class="member-role" *ngIf="techDetails?.job_describtion">
                            <span class="role-badge">{{techDetails?.job_describtion}}</span>
                            <span class="role-faculty" *ngIf="techDetails?.faculty"> — {{techDetails?.faculty}}</span>
                        </div>
                        <ul class="member-meta list-unstyled">
                            <li *ngIf="techDetails?.birthdate">
                                <span class="meta-label">تاريخ الميلاد</span>
                                <span class="meta-value">{{techDetails?.birthdate}}</span>
                            </li>
                            <li *ngIf="techDetails?.nationality">
                                <span class="meta-label">الجنسية</span>
                                <span class="meta-value">{{techDetails?.nationality}}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Content grid -->
                <div class="member-content">

                    <!-- Scientific & intellectual production -->
                    <article class="info-card" *ngIf="hasText(techDetails?.Scientific_intellectual_production)">
                        <header class="info-card-head">
                            <span class="info-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                                </svg>
                            </span>
                            <h2>الإنتاج الفكري والفلسفي</h2>
                        </header>
                        <ul class="bullet-list">
                            <li *ngFor="let line of splitToList(techDetails?.Scientific_intellectual_production)">
                                {{line}}
                            </li>
                        </ul>
                    </article>

                    <!-- Scholarships & courses -->
                    <article class="info-card" *ngIf="hasText(techDetails?.Scholarships_curricula)">
                        <header class="info-card-head">
                            <span class="info-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                                    <path d="M6 12v5c3 3 9 3 12 0v-5" />
                                </svg>
                            </span>
                            <h2>البعثات والمنح والدورات</h2>
                        </header>
                        <ul class="bullet-list">
                            <li *ngFor="let line of splitToList(techDetails?.Scholarships_curricula)">
                                {{line}}
                            </li>
                        </ul>
                    </article>

                    <!-- References & encyclopedias -->
                    <article class="info-card" *ngIf="hasText(techDetails?.References_encyclopedias)">
                        <header class="info-card-head">
                            <span class="info-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
                                    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
                                </svg>
                            </span>
                            <h2>المراجع والموسوعات المدرج فيها اسمه</h2>
                        </header>
                        <ul class="bullet-list">
                            <li *ngFor="let line of splitToList(techDetails?.References_encyclopedias)">
                                {{line}}
                            </li>
                        </ul>
                    </article>

                    <!-- Academic qualifications (timeline) -->
                    <article class="info-card"
                        *ngIf="techDetails?.Academic_qualifications_certificates?.length">
                        <header class="info-card-head">
                            <span class="info-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M22 10L12 5 2 10l10 5 10-5z" />
                                    <path d="M6 12v5c0 1 2.7 2.5 6 2.5s6-1.5 6-2.5v-5" />
                                </svg>
                            </span>
                            <h2>المؤهلات العلمية والشهادات</h2>
                        </header>
                        <ul class="timeline">
                            <li *ngFor="let item of sortByDateDesc(techDetails?.Academic_qualifications_certificates)">
                                <span class="timeline-year" *ngIf="getYear(item.acquire_date)">{{getYear(item.acquire_date)}}</span>
                                <div class="timeline-body">
                                    <h3 class="timeline-title">{{item.title}}</h3>
                                    <p class="timeline-org" *ngIf="item.org">{{item.org}}</p>
                                </div>
                            </li>
                        </ul>
                    </article>

                    <!-- Jobs & professions (timeline) -->
                    <article class="info-card" *ngIf="techDetails?.Jobs_professions?.length">
                        <header class="info-card-head">
                            <span class="info-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <rect x="2" y="7" width="20" height="14" rx="2" />
                                    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                                </svg>
                            </span>
                            <h2>التدرج الوظيفي والمهني</h2>
                        </header>
                        <ul class="timeline">
                            <li *ngFor="let item of sortByDateDesc(techDetails?.Jobs_professions)">
                                <span class="timeline-year" *ngIf="getYear(item.acquire_date)">{{getYear(item.acquire_date)}}</span>
                                <div class="timeline-body">
                                    <h3 class="timeline-title">{{item.title}}</h3>
                                    <p class="timeline-org" *ngIf="item.org">{{item.org}}</p>
                                </div>
                            </li>
                        </ul>
                    </article>

                    <!-- Honors & awards (timeline) -->
                    <article class="info-card" *ngIf="techDetails?.honors_awards?.length">
                        <header class="info-card-head">
                            <span class="info-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                                    stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="8" r="6" />
                                    <path d="M8.21 13.89 7 23l5-3 5 3-1.21-9.12" />
                                </svg>
                            </span>
                            <h2>الأوسمة والجوائز</h2>
                        </header>
                        <ul class="timeline">
                            <li *ngFor="let item of sortByDateDesc(techDetails?.honors_awards)">
                                <span class="timeline-year" *ngIf="getYear(item.acquire_date)">{{getYear(item.acquire_date)}}</span>
                                <div class="timeline-body">
                                    <h3 class="timeline-title">{{item.title}}</h3>
                                    <p class="timeline-org" *ngIf="item.org">{{item.org}}</p>
                                </div>
                            </li>
                        </ul>
                    </article>

                </div>

                <!-- Empty state when the member has no extra details -->
                <div class="member-empty" *ngIf="techDetails && !hasAnyContent()">
                    <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <path d="M14 2v6h6M9 13h6M9 17h4" />
                    </svg>
                    <p>لا توجد بيانات إضافية متاحة حاليًا لعضو هيئة التدريس.</p>
                </div>

            </div>
        </section>
    </main>
</div>
